export default __webpack_public_path__ + "static/media/excel_icon.b8679c7e.png";